import { formatTime, relativeTime } from '@pryme/ui';
import { describeEvent, isFailure } from '../lib/events';
import { parseDetail, type DevEvent } from '../lib/types';

export function EventList(props: { events: DevEvent[]; compact?: boolean; serviceName?: (e: DevEvent) => string | undefined }) {
  if (props.events.length === 0) return <p className="p-muted p-small" style={{ margin: 0 }}>No events yet. Sign-ins, signed requests and mandate decisions appear here.</p>;
  if (props.compact) {
    return (
      <ul className="dv-events">
        {props.events.map((e) => (
          <li key={`${e.id}-${e.kind}`}>
            <span className="dv-ev-title">{describeEvent(e.kind)}</span>
            <span className="dv-ev-side">
              <span className={`p-status ${isFailure(e) ? 'bad' : 'ok'}`}>{e.result_code}</span>
              <span className="dv-ev-time" title={formatTime(e.occurred_at)}>{relativeTime(e.occurred_at)}</span>
            </span>
            <span className="dv-ev-meta">
              {props.serviceName?.(e) ? `${props.serviceName(e)} · ` : ''}
              <code>{e.kind}</code>
            </span>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <div className="p-table-wrap">
      <table className="p-table">
        <thead>
          <tr>
            <th scope="col">When</th>
            {props.serviceName && <th scope="col">Service</th>}
            <th scope="col">Event</th>
            <th scope="col">Result</th>
            {!props.compact && <th scope="col">Detail</th>}
          </tr>
        </thead>
        <tbody>
          {props.events.map((e) => {
            const d = parseDetail(e.detail);
            return (
              <tr key={`${e.id}-${e.kind}`}>
                <td title={formatTime(e.occurred_at)} style={{ whiteSpace: 'nowrap' }}>{relativeTime(e.occurred_at)}</td>
                {props.serviceName && <td className="p-small">{props.serviceName(e)}</td>}
                <td>
                  <div>{describeEvent(e.kind)}</div>
                  <code className="p-small p-muted">{e.kind}</code>
                </td>
                <td><span className={`p-status ${isFailure(e) ? 'bad' : 'ok'}`}>{e.result_code}</span></td>
                {!props.compact && (
                  <td className="p-small">
                    {Object.keys(d).length ? Object.entries(d).map(([k, v]) => <div key={k}><span className="p-muted">{k}:</span> <code>{String(v)}</code></div>) : <span className="p-muted">—</span>}
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
